import { CSS, Flex } from '@ghq-abi/design-system';

import { AttentionTooltip } from '../AttentionTooltip';
import { Avatar } from '../Avatar';

import { Content } from './Content';
import { EmployeeProfileSeverityType } from './ProfileContainer';

export type EmployeeProfileStatus = {
  message: string;
  severity: EmployeeProfileSeverityType;
};

type PersonalProfileProps = {
  variant?: 'card' | 'table';
  name?: string;
  firstName?: string;
  lastName?: string;
  secondaryText?: string;
  globalId?: string;
  css?: CSS;
  status?: EmployeeProfileStatus;
  avatarSize?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
};

const ATTENTION_TOOLTIP_DEFAULT_SIZE = '24px';

export function PersonalProfile({
  name = '',
  firstName = '',
  lastName = '',
  secondaryText = '',
  globalId = '',
  css,
  status,
  avatarSize = 'sm',
  variant = 'card',
  disabled,
}: PersonalProfileProps) {
  const variants = {
    card: {
      gap: '$sm',
      width: '$auto',
    },
    table: {
      position: 'relative',
      gap: '$lg',
      width: '$3xs',
    },
  };

  return (
    <Flex
      gap="sm"
      align="center"
      justify="center"
      css={{
        color: disabled ? '$gray525' : 'inherit',
        ...variants[variant],
        ...css,
      }}
    >
      <Flex id="employee-profile-status" gap="sm" align="center">
        <Flex
          css={{
            width:
              variant === 'table' ? ATTENTION_TOOLTIP_DEFAULT_SIZE : 'auto',
            height:
              variant === 'table' ? ATTENTION_TOOLTIP_DEFAULT_SIZE : 'auto',
          }}
        >
          {status && (
            <AttentionTooltip
              message={status.message}
              severity={status.severity}
            />
          )}
        </Flex>
        <Avatar name={name} globalId={globalId} size={avatarSize} />
      </Flex>
      <Flex css={{ flexGrow: 1 }} direction="column" justify="center">
        <Content.FirstAndLastName
          name={name}
          firstName={firstName}
          lastName={lastName}
        />
        {secondaryText && <Content.SecondaryText text={secondaryText} />}
      </Flex>
    </Flex>
  );
}
